import React, {FC, Dispatch, createContext, useReducer} from 'react';
import {initialState, informerConfigReducer, InformerConfigState, Action} from './informerConfigReducer';

export const InformerConfigContext = createContext<{
	state: InformerConfigState;
	dispatch: Dispatch<Action>;
} | null>(null);

interface InformerConfigProviderProps {
	defaultLanguage: string;
}

export const InformerConfigProvider: FC<InformerConfigProviderProps> = props => {
	const {defaultLanguage, children} = props;
	const [state, dispatch] = useReducer(informerConfigReducer, {...initialState, language: defaultLanguage});

	return <InformerConfigContext.Provider value={{state, dispatch}}>{children}</InformerConfigContext.Provider>;
};
